export interface ImageFileProps {
  fileSize: number;
  type: string;
  width: number;
  height: number;
}

export interface FileProps {
  fileSize: number;
  type: string;
}

// Profile picture validation constants
export const IMAGE_TYPE = ["image/jpeg", "image/png"];
const IMAGE_RESOLUTION_MIN_WIDTH = 140;
const IMAGE_RESOLUTION_MIN_HEIGHT = 100;
const IMAGE_MAX_FILE_SIZE = 10 * 1024 * 1024;
export const ERROR_MESSAGE = "Veuillez uploader une image au format jpg ou png de 10mo max (140*100px minimum)";

const hasCorrectResolution = ({ width, height }: ImageFileProps): boolean => {
  const validWidthResolution = width >= IMAGE_RESOLUTION_MIN_WIDTH;
  const validHeightResolution = height >= IMAGE_RESOLUTION_MIN_HEIGHT;
  const isValid = validHeightResolution && validWidthResolution;
  return isValid;
};

const isCorrectImageType = (type: string): boolean => {
  return IMAGE_TYPE.includes(type);
};

const isCorrectImageSize = (fileSize: number): boolean => {
  return fileSize < IMAGE_MAX_FILE_SIZE;
};

export const isImageFile = (value: string | null): boolean => {
  return !!value?.match(/\.(jpg|jpeg|png|gif|webp)/i);
};

export const isValidImageFile = (fileProps: ImageFileProps): string | null => {
  const fileIsCorrectType = isCorrectImageType(fileProps.type);
  if (!fileIsCorrectType) {
    return "Type de fichier non valide";
  }

  const fileHasCorrectResolution = hasCorrectResolution(fileProps);
  if (!fileHasCorrectResolution) {
    return "Résolution d'image non valide";
  }

  const fileIsCorrectSize = isCorrectImageSize(fileProps.fileSize);
  if (!fileIsCorrectSize) {
    return "Taille de fichier non valide";
  }

  return null;
};

// Bio & Resume upload
export const PDF_MAX_FILE_SIZE = 10 * 1024 * 1024;
export const PDF_FILETYPE = ["application/pdf"];

// Invoice upload
export const INVOICE_MAX_FILE_SIZE = 10 * 1024 * 1024;
export const INVOICE_FILETYPE = ["application/pdf", "image/jpeg", "image/png"];
